import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when several groups share the same id.
 *
 * @param {string} spec.duplicatedGroupId - Account group id that is used by several groups.
 */
export default class DuplicateGroupIdValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor({ duplicatedGroupId }) {
		super(...arguments);

		this._duplicatedGroupId = duplicatedGroupId;
	}

	getMessage() {
		return _('Two account groups share the same id "{groupId}".', {
			groupId: this._duplicatedGroupId,
		});
	}

	static getType() {
		return "DuplicateGroupIdValidationResult";
	}
}
